module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_vm._t("show-settings"), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-grid-small uk-child-width-auto@s uk-flex-between@s tm-show-settings",
    attrs: {
      "uk-grid": ""
    }
  }, [_vm._t("selected-filters")], 2)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-grid-medium",
    attrs: {
      "uk-grid": ""
    }
  }, [_vm._t("shop-filters"), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-1 uk-width-expand@m"
  }, [_c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('shop-items-pagination', _vm._g({
    attrs: {
      "total-pages": _vm.ShopItems.total_pages,
      "last-page": _vm.ShopItems.last,
      "current-page": _vm.ShopItems.current,
      "next-page": _vm.ShopItems.next,
      "previous-page": _vm.ShopItems.before
    }
  }, _vm.$listeners)), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-grid-medium uk-grid-match uk-child-width-1-3@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.ShopItems.items), function(Product) {
    return _c('product', _vm._g({
      key: Product.ShopItem.id,
      attrs: {
        "shop-item": Product.ShopItem,
        "image": Product.Asset !== undefined ? Product.Asset : Product.ShopItem.image,
        "shop-product": Product.ShopProduct,
        "shop-item-prices": _vm.ShopItemPrices[Product.ShopItem.id],
        "related-shop-items": _vm.ShopItemsRelated[Product.ShopItem.id],
        "shop-item-properties": _vm.ShopItemProperties[Product.ShopItem.id],
        "shop-item-warehouses": _vm.ShopItemWarehouses[Product.ShopItem.id],
        "shop-item-tags": _vm.ShopItemTags[Product.ShopItem.id],
        "shop-order-item": _vm.ShopOrderItems[Product.ShopItem.id]
      }
    }, _vm.$listeners))
  }), 1)]), _vm._v(" "), _c('shop-items-pagination', _vm._g({
    attrs: {
      "total-pages": _vm.ShopItems.total_pages,
      "last-page": _vm.ShopItems.last,
      "current-page": _vm.ShopItems.current,
      "next-page": _vm.ShopItems.next,
      "previous-page": _vm.ShopItems.before
    }
  }, _vm.$listeners))], 1)])], 2)])])]), _vm._v(" "), _c('a', {
    staticClass: "uk-button uk-button-primary",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "id": "js-scroll"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d90e9f5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/ShopProducts.vue
// module id = 74
// module chunks = 0